define("checkout/components/payment/card", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="payment-card" id="payment-form" ...attributes {{did-insert this.setupStripeForm}}>
    <div class="o--formWrapper">
      <div class="u--clearfix u--m__b__xs">
        <label class="u--m__b__0 u--m__t__xs" for="e--card-element">{{t "plans.checkout.plan.card_type"}}</label>
        <span class="u--float--right"><img src="/assets/images/img--payment-type.svg" /></span>
      </div>
      <div class="o--form__input u--m__b__sm qa--creditCard_input u--hide--mf" id="e--card-element">
        {{! a Stripe Element will be inserted here. }}
      </div>
      {{! Used to display form errors }}
      <div class="o--form__helpText u--text--danger" data-test-id="error" id="e--card-errors">
        {{this.cardError}}
        {{#if (and this.hasTouchedCard @isCardEmpty)}}
          <span>
            {{t "plans.checkout.card.missing_info"}}
          </span>
        {{/if}}
      </div>
    </div>
  </div>
  */
  {
    "id": "0J4D6o+s",
    "block": "[[[11,0],[24,\"data-test-id\",\"payment-card\"],[24,1,\"payment-form\"],[17,1],[4,[38,0],[[30,0,[\"setupStripeForm\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--clearfix u--m__b__xs\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"u--m__b__0 u--m__t__xs\"],[14,\"for\",\"e--card-element\"],[12],[1,[28,[35,1],[\"plans.checkout.plan.card_type\"],null]],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--float--right\"],[12],[10,\"img\"],[14,\"src\",\"/assets/images/img--payment-type.svg\"],[12],[13],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"o--form__input u--m__b__sm qa--creditCard_input u--hide--mf\"],[14,1,\"e--card-element\"],[12],[1,\"\\n\"],[1,\"    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"o--form__helpText u--text--danger\"],[14,\"data-test-id\",\"error\"],[14,1,\"e--card-errors\"],[12],[1,\"\\n      \"],[1,[30,0,[\"cardError\"]]],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"hasTouchedCard\"]],[30,2]],null],[[[1,\"        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"plans.checkout.card.missing_info\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@isCardEmpty\"],false,[\"did-insert\",\"t\",\"if\",\"and\"]]",
    "moduleName": "checkout/components/payment/card.hbs",
    "isStrictMode": false
  });

  let CardComponent = (_class = class CardComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "stripe", _descriptor, this);

      _defineProperty(this, "stripeFormLoaded", false);

      _initializerDefineProperty(this, "cardError", _descriptor2, this);

      _initializerDefineProperty(this, "hasTouchedCard", _descriptor3, this);
    }

    async setupStripeForm() {
      const card = await this.stripe.createCard('#e--card-element');

      if (!card) {
        return;
      }

      card.addEventListener('change', state => {
        this.cardError = state?.error?.message || '';
        this.args.onCard({
          card,
          state
        });
      });
      card.addEventListener('focus', () => {
        this.hasTouchedCard = true;
      });
      this.stripeFormLoaded = true;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cardError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hasTouchedCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setupStripeForm", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setupStripeForm"), _class.prototype)), _class);
  _exports.default = CardComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CardComponent);
});